import React from 'react';

const invertAngle = angle => {
  return 90 - angle;
};

export class SideShadingDevice extends React.Component {
  render() {
    const {
      side,
      origin: { x, y, z },
      size: { width, height },
      isHighLight,
    } = this.props;
    let classNames = ['sheet'];
    if (isHighLight) {
      classNames = [...classNames, 'active'];
    }
    classNames = [...classNames, `sheet-${side}`];
    return (
      <div
        className={classNames.join(' ')}
        style={{
          transform: `rotateY(-90deg) translateX(${x}em) translateY(${z}em) translateZ(${-y}em)`,
          width: `${width}em`,
          height: `${height}em`,
        }}
      >
        <div
          className="side front"
          style={{ width: `${width}em`, height: `${height}em` }}
        />
        <div
          className="side back"
          style={{ width: `${width}em`, height: `${height}em` }}
        />
        <div
          className="side side-width-thin right"
          style={{
            left: `calc((${width}em - 0.1em) / 2.0 )`,
            transform: `rotateY(90deg) translateZ(${width / 2}em)`,
            height: `${height}em`,
          }}
        />
        <div
          className="side side-width-thin left"
          style={{ height: `${height}em` }}
        />
        <div
          className="side side-height-thin top"
          style={{ width: `${width}em` }}
        />
        <div
          className="side side-height-thin bottom"
          style={{
            top: `calc((${height}em - 0.1em) / 2.0 )`,
            transform: `rotateX(-90deg) translateZ(${height * 0.5}em)`,
            width: `${width}em`,
          }}
        />
      </div>
    );
  }
}

export class FrontShadingDevice extends React.Component {
  render() {
    const {
      origin: { x, y, z },
      size: { width, height: length },
      xAngle,
      isHighLight,
    } = this.props;
    let classNames = ['sheet', 'sheet-front'];
    if (isHighLight) {
      classNames = [...classNames, 'active'];
    }

    return (
      <div
        className={classNames.join(' ')}
        style={{
          height: `${length}em`,
          width: `${width}em`,
          transform: `translateX(${y}em) translateY(${z}em) translateZ(${x}em) rotateX(${-invertAngle(xAngle)}deg)`
        }}
      >
        <div
          className="side front"
          style={{ height: `${length}em`, width: `${width}em` }}
        />
        <div
          className="side back"
          style={{ height: `${length}em`, width: `${width}em` }}
        />
        <div
          className="side side-width-thin right"
          style={{
            height: `${length}em`,
            left: `calc((${width}em - 0.1em) / 2.0 )`,
            transform: `rotateY(90deg) translateZ(${width / 2}em)`,
          }}
        />
        <div
          className="side side-width-thin left"
          style={{ height: `${length}em` }}
        />
        <div
          className="side side-height-thin top"
          style={{ width: `${width}em` }}
        />
        <div
          className="side side-height-thin bottom"
          style={{
            width: `${width}em`,
            top: `calc((${length}em - 0.1em) / 2.0 )`,
            transform: `rotateX(-90deg) translateZ(${length / 2}em)`,
          }}
        />
      </div>
    );
  }
}

export class TopShadingDevice extends React.Component {
  render() {
    const {
      origin: { x, y, z },
      size: { width, height: length },
      xAngle,
      isHighLight,
    } = this.props;
    let classNames = ['sheet', 'sheet-top'];
    if (isHighLight) {
      classNames = [...classNames, 'active'];
    }

    return (
      <div
        className={classNames.join(' ')}
        style={{
          height: `${length}em`,
          width: `${width}em`,
          transform: `translateX(${y}em) translateY(${z}em) translateZ(${x}em) rotateX(${invertAngle(-xAngle)}deg)`
        }}
      >
        <div
          className="side front"
          style={{ height: `${length}em`, width: `${width}em` }}
        />
        <div
          className="side back"
          style={{ height: `${length}em`, width: `${width}em` }}
        />
        <div
          className="side side-width-thin right"
          style={{
            height: `${length}em`,
            left: `calc((${width}em - 0.1em) / 2.0 )`,
            transform: `rotateY(90deg) translateZ(${width / 2}em)`,
          }}
        />
        <div
          className="side side-width-thin left"
          style={{ height: `${length}em` }}
        />
        <div
          className="side side-height-thin top"
          style={{ width: `${width}em` }}
        />
        <div
          className="side side-height-thin bottom"
          style={{
            width: `${width}em`,
            top: `calc((${length}em - 0.1em) / 2.0 )`,
            transform: `rotateX(-90deg) translateZ(${length / 2}em)`,
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sc_editor/ShadingDevices.js